<email-layout>
  <ng-container logo>
    <email-tellent-logo />
  </ng-container>

  <ng-container header>
    <email-message-header
      [header]="data().title"
      [subheader]="data().p1"
      [imageUrl]="data().avatar_url"
      [avatarAlignTop]="true"
      subheaderClassName="web-tellent-contains-link"
    />
  </ng-container>

  <ng-container body>
    <email-text [contents]="data().p2" className="web-tellent-contains-link" />
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data().footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data().footer.label"
      [href]="data().footer.href"
      [target]="data().footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
    <email-margin [height]="16" />
    <email-tellent-products-footer />
  </ng-container>
</email-layout>
